import type {FC} from 'react';
import {MdOutlineBookmark} from 'react-icons/md';
import {COLOR_SUB, COLOR_WHITE} from '../../config/constants/colorCodes';

type Props = {
  count: string;
  isClipped: boolean;
  handleUpdate: () => Promise<void>;
};

const ClipIcon: FC<{isClipped: boolean}> = ({isClipped}) => {
  if (isClipped) {
    return <MdOutlineBookmark color={COLOR_WHITE} size="13px" />;
  }

  return <MdOutlineBookmark color={COLOR_SUB} size="13px" />;
};

export const FavoriteButton: FC<Props> = ({count, isClipped, handleUpdate}) => (
  <button
    className={`rounded-4 ${
      isClipped ? 'border-white bg-sub' : 'border-sub bg-white'
    } w-auto min-w-[55px] max-w-[65px] border-[1px]`}
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      void handleUpdate();
    }}
  >
    <span className="leading-20 flex h-20 items-center justify-between px-4">
      <ClipIcon isClipped={isClipped} />
      <span className={`${isClipped ? 'text-white' : 'text-sub'} text-sm`}>
        {count}
      </span>
    </span>
  </button>
);
